import { BRANDS, DEFAULT_BRAND } from '../config/brands';
import { deQuotedPrintable } from './submission';

let brandCache = null;

export function detectBrand() {
  if (brandCache) {
    return brandCache;
  }

  const urlParams = new URLSearchParams(deQuotedPrintable(window.location.search));
  const brandParam = urlParams.get('brand')?.toLowerCase();

  if (brandParam) {
    for (const brandKey in BRANDS) {
      const brand = BRANDS[brandKey];
      if (brand.id.toLowerCase() === brandParam || brand.name.toLowerCase() === brandParam) {
        brandCache = brand;
        return brand;
      }
    }
  }

  const hostname = window.location.hostname.toLowerCase();

  for (const brandKey in BRANDS) {
    const brand = BRANDS[brandKey];
    const matchedDomain = brand.domains.find((domain) =>
      hostname.includes(domain.toLowerCase())
    );

    if (matchedDomain) {
      brandCache = brand;
      return brand;
    }
  }

  brandCache = DEFAULT_BRAND;
  return DEFAULT_BRAND;
}

export function clearBrandCache() {
  brandCache = null;
}

export function isBrand(brandId) {
  const currentBrand = detectBrand();
  return currentBrand.id === brandId;
}
